<template>
    <b-card>
        <div v-if="loading" class="loading"/>

        <div class="mb-2 mt-2">
            <div class="d-block d-md-inline-block pt-1">
                <h4 class="mb-2 card-title">List of Incidents</h4>
            </div>

            <div class="float-md-right pt-1">
                <span class="text-muted text-small mr-1 mb-2">{{ meta.from }}-{{ meta.to }} of {{ meta.total }}</span>
                <b-dropdown id="ddown2" right :text="`${meta.per_page}`" variant="outline-dark"
                            class="d-inline-block" size="xs">
                    <b-dropdown-item v-for="(size,index) in meta.page_sizes" :key="index"
                                     @click="changePageSize(size)">{{ size }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <b-table show-empty no-sort-reset class="vuetable" :current-page="meta.current_page" :per-page="meta.per_page"
                 :fields="table.fields" :items="fetchFacilityIncidents">
            <template v-slot:cell(id)="data">
                <router-link class="text-data-link" :to="{path : '/hms/compliances/' + data.item.links.self}"
                             v-text="data.item.data.attributes.code"/>
            </template>

            <template v-slot:cell(date)="data">
                <span v-text="data.item.data.attributes.date"/>
            </template>

            <template v-slot:cell(time)="data">
                <span v-text="data.item.data.attributes.time"/>
            </template>

            <template v-slot:cell(priority)="data">
                <span v-text="data.item.data.attributes.priority"/>
            </template>

            <template v-slot:cell(facility)="data">
                <span v-text="data.item.data.attributes.facility"/>
            </template>

            <template v-slot:cell(incident_type)="data">
                <span v-text="data.item.data.attributes.incident_type"/>
            </template>

            <template v-slot:cell(reviewed_by)="data">
                <span v-text="data.item.data.attributes.reviewed_by"/>
            </template>

            <template v-slot:cell(status)="data">
                <b-badge pill style="width: 85px;"
                         :variant="data.item.data.attributes.status === 'Reviewed' ? 'success' : 'warning'">
                    {{ data.item.data.attributes.status }}
                </b-badge>
            </template>
        </b-table>

        <b-pagination size="sm" align="center" :total-rows="meta.total" :per-page="meta.per_page"
                      v-model="meta.current_page">
            <template v-slot:next-text>
                <i class="simple-icon-arrow-right"/>
            </template>

            <template v-slot:prev-text>
                <i class="simple-icon-arrow-left"/>
            </template>

            <template v-slot:first-text>
                <i class="simple-icon-control-start"/>
            </template>

            <template v-slot:last-text>
                <i class="simple-icon-control-end"/>
            </template>
        </b-pagination>
    </b-card>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "FacilityComplaintsList",
        data() {
            return {
                loading: true,
                table: {
                    fields: [
                        {key: 'id', label: 'Code'},
                        {key: 'date', label: 'Date', tdClass: 'text-muted'},
                        {key: 'time', label: 'Time', tdClass: 'text-muted'},
                        {key: 'priority', label: 'Priority', tdClass: 'text-muted'},
                        {key: 'incident_type', label: 'Incident Type', tdClass: 'text-muted'},
                        {key: 'reviewed_by', label: 'Reviewed By', tdClass: 'text-muted'},
                        {key: 'status', label: 'Status', thClass: 'text-center', tdClass: 'text-center'},
                    ]
                }
            }
        },

        computed: {
            ...mapGetters({
                meta: 'getFacilityIncidentsMeta',
            }),
        },

        methods: {
            changePageSize(per_page) {
                this.meta.per_page = per_page;
            },

            fetchFacilityIncidents() {
                return this.$store.dispatch('fetchFacilityIncidents', this.$route.params.facility_id)
                    .then(incidents => {
                        return incidents.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
        }
    }
</script>

<style scoped>

</style>
